import { login } from '@/api/login'
import { setToken, removeToken } from '@/utils/auth'
const getDefaultState = () => {
  return {
    name: '',
    avatar: '',
    menu_my: [
      {
        top_menu: "合作商列表",
        top_index: 1,
        top_page:"pt",
      },{
        top_menu: "客户列表",
        top_index: 2,
        top_page:"kh",
      },
      {
        top_menu: "装备汇总",
        top_index: 3,
        top_page:"Contract_Management",
      },
      {
        top_menu: "区域汇总",
        top_index:4,
        top_page:"Node_Management",
      },{
        top_menu: "行业汇总",
        top_index: 5,
        top_page:"industry",
      }
    ],
    roles: [],
    showMessaheg: false,
    permissions: [],
    part_lists: [],
    sendPart_list: [],
    vendor_list: [],
  }
  
}
const state = getDefaultState()
const mutations = {
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    console.log(avatar)
    state.avatar = avatar
  },
  // SET_MENU: (state, menu) => {
  //   state.menu = menu
  // },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  CHAN_GEMSG: (state) => {
    state.showMessaheg = !state.showMessaheg
  },
}
const actions = {
  // 登录
  Login({ commit }, userInfo) {
    console.log(userInfo)
    const uid = userInfo.uid.trim()
    const pid = userInfo.pid
    const com_id = userInfo.com_id
    return new Promise((resolve, reject) => {
      let data = {
        uid:uid,
        pid:pid,
        com_id:com_id,
      }
      login(data).then(res => {
        let obj = {
          username: uid,
          password: pid,
          com_id:com_id
        }
        window.localStorage.setItem("user", JSON.stringify(obj))
        const data = {
          token: 'qwertyiop'
        }
        commit('SET_TOKEN', data.token)
        // commit('SET_MENU', res?.menus)
        console.log(res)
        // window.localStorage.setItem("company", JSON.stringify(res.company))
        commit('SET_NAME', res.company_name)
        commit('SET_AVATAR', res.company_logo)
        setToken(data.token)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  chnageSate({ commit }) {
    commit('CHAN_GEMSG')
  },
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
